import React, { FC, useContext } from 'react';

import { PaginationContext } from '../PaginationContext';
import { Paginator } from '../Paginator';

export const PaginationPaginator: FC<any> = () => {
  const context = useContext(PaginationContext);
  const showPaginator = context.perPage !== 0 && context.count > 0;

  return <div style={{ minHeight: '5.5rem' }}>{showPaginator && <Paginator />}</div>;
};
